import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as reportGeneration from '../../../../../redux/reportGeneration';
import useReportContainer from '../context/useReportContainer';
import type { Revision } from '../../../../../../shared/model-typings';
import type { ReportCategory } from '../../shared/types';

import ProjectActionButtons from './ProjectActionButtons';
import ProjectGroupActionButtons from './ProjectGroupActionButtons';

type Props = {
  isDisabled?: boolean;
  reportType: ReportCategory;
  revision?: Revision;
};

const ActionButtons: VoidFunctionComponent<Props> = ({
  reportType,
  isDisabled,
  revision,
}: Props) => {
  const projectType = useSelector(reportGeneration.selectors.getProjectType);
  const {
    format,
    includeOptions,
    dependencyMetadataOptions,
    fixPlanOptions,
    authorName,
    authorEmail,
    supplier,
    excludeOptions,
  } = useReportContainer();

  return projectType === 'project' ? (
    <ProjectActionButtons
      format={format}
      reportType={reportType}
      includeOptions={includeOptions}
      dependencyMetadataOptions={dependencyMetadataOptions}
      fixPlanOptions={fixPlanOptions}
      isDisabled={isDisabled}
      revision={revision}
      authorName={authorName}
      authorEmail={authorEmail}
      supplier={supplier}
      excludeOptions={excludeOptions}
    />
  ) : (
    <ProjectGroupActionButtons
      format={format}
      reportType={reportType}
      includeOptions={includeOptions}
      dependencyMetadataOptions={dependencyMetadataOptions}
      fixPlanOptions={fixPlanOptions}
      excludeOptions={excludeOptions}
      isDisabled={isDisabled}
      authorName={authorName}
      authorEmail={authorEmail}
      supplier={supplier} />
  );
};

export default ActionButtons;
